interface Props {
  val: string;
  onChange: (val: string) => void;
  allowBlank?: boolean;
}

/**
 * 文字列入力フィールド
 * @param props
 * @returns
 */
const InputText = ({ val, onChange, allowBlank }: Props) => {
  return (
    <input
      type="text"
      value={val}
      onChange={e => onChange(e.target.value)}
      required={!allowBlank}
    />
  );
};
export default InputText;
